<template>
  <div>
    <PartnerHeader :img_header="header_image" header="จัดโปรโมชั่นแถมราคาถูกสุด" link_back="promotioninformation"/>
    <MenuPartner/>
    <Promotion_add_pos_free/>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/process.png";
// import MenuPartner from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import Promotion_add_pos_free from "@/components/admin/manage_pos/partner_store_setting/Promotion_add_pos_free";
export default {
  name: "PromotionAddPosFree",
  components: {
    Promotion_add_pos_free,
    // MenuPartner,
    PartnerHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
